<template>
	<div>
		<h2 class="clearfix mb-4">
			{{$t('edit')}}
			<div class="float-right">
				<button @click="saveStaticURL" class="btn btn-primary" :disabled="!canSave">{{ $t('save') }}</button>
                <!--START DROPDOWN-->
                <b-dropdown
                    v-if="static_url.id"
                    id="dropdown-1"
                    :text="currentStatusText"
                    class="my-auto ml-2"
                    :variant="static_url.status == 1 ? 'success' : 'secondary'"
                >
                    <b-dropdown-item
                        v-if="static_url.status == 1"
                        @click="openDialog('disable')">
                            {{ $t('disable') }}
                        </b-dropdown-item>
                    <b-dropdown-item
                        v-if="static_url.status != 1"
                        @click="openDialog('activate')">
                            {{ $t('activate') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="openDialog('delete')">
                            {{ $t('delete') }}
                    </b-dropdown-item>
                </b-dropdown>
                <!--END DROPDOWN-->
			</div>
		</h2>

		<div class="row mb-4">
			<div class="col-12 col-xl-7">

				<TextInput
					:label="$t('title')"
					v-model="static_url.title"
				/>

				<TextAreaAutosize
					:label="$t('description')"
					v-model="static_url.note"
					class="mb-4"
				/>

                <h2>
                    {{$t('select-form')}}
                </h2>
                <FormsPicker
                    v-model="static_url.form"
                    :loading="loading"
                    :limit="1"
                />

                <h2>
                    {{$t('select-signer')}}
                </h2>
                <UserSelector
                    v-model="static_url.usersignofffrom"
                    :users="users"
                    :loading="loading"
                    displayKey="displayname"
                    :limit="1"
                />

			</div>

			<div class="col-12 col-xl-5">
                <div class="row" v-if="static_url.token">
                    <div class="col-12 col-lg-5 col-xl-12 mb-4">
						<h2>{{ $t('qr-code-and-url')}}</h2>
                        <div class="mb-1">
                            <img
                                :src="`${$settings.APIBaseURL}/staticurls/getqr?id=${static_url.id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=md`"
                                style="width:350px"
                                @click="showtoken=true"
                                @load="qrloaded = true"
                            />
                            <b-skeleton-img width="350px" v-if="!qrloaded"></b-skeleton-img>
				        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <a href="#" @click.prevent="copyToClipboard(baseURL)">
                            <p class="my-auto">
                                {{ baseURL }}
                                <b-icon class="ml-1" icon="clipboard" v-if="!copied"></b-icon>
                                <b-badge variant="light" v-if="copied">{{ $t('copied') }}</b-badge>
                            </p>
                            </a>
                        </div>
					</div>
                </div>
			</div>

            <!-- BEGIN SHOW TOKEN -->
            <div v-if="static_url.token" v-show="showtoken" style="background: #FFFFFF; z-index: 20000; position: fixed; top: 0; bottom: 0; left: 0; right: 0; padding: 20px">
                <div class="clearfix">
                    <div class="float-right; text-right">
                        <a
                            class="btn btn-light mr-2"
                            download="staticurlcode.png"
                            :href="`${$settings.APIBaseURL}/staticurls/getqr?id=${static_url.id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=xl&dl=1`"
                            title="staticurlcode.png"
                        >
                            {{$t('download')}}
                        </a>
                        <button class="btn btn-light" @click="showtoken=false"><b-icon-x></b-icon-x></button>
                    </div>
                </div>
                <div class="text-center">
                    <h1 style="font-size: 60px">{{static_url.token}}</h1>
                    <img
                        :src="`${$settings.APIBaseURL}/staticurls/getqr?id=${static_url.id}&username=${$UserSession.getValue('username')}&authToken=${$UserSession.getValue('authToken')}&size=xl`"
                        style="width: 100%; max-width: 525px"
                    />

                </div>
            </div>
            <!-- END SHOW TOKEN -->
		</div>
    </div>
</template>

<script>
import FormsPicker from "src/components/FormResponses/FormSelector";
import UserSelector from "src/components/Users/UserSelector";

export default {
	components: {
		FormsPicker,
        UserSelector
	},
	mounted() {

        let to_load = [this.fetchStaticURL(), this.getUsers()];

		Promise.all(to_load)
            .then(() => {
                this.loading = false;
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.loading = false; 
            });

	},
    data() {
        return {
			loading: true,
			submitting: false,
        	tabIndex: 0,
        	static_url: {
        		id: null,
				form_id: null,
        		title: '',
        		note: '',
                form: [],
                usersignofffrom : []
        	},
        	saved: false,
            users:[],
            showtoken:false,
            copied:false,
            qrloaded: false,
            total_url: ''
        }
    },
    watch: {
        users(newUsers) {
            
            if (this.static_url.usersignofffrom_id) {
                this.static_url.usersignofffrom = newUsers.filter(user => user.id == this.static_url.usersignofffrom_id);
            }
        }
    },
    methods: {
    	saveStaticURL() {
			if (this.submitting) return
			this.submitting = true

            // Just send Form ID
            if(this.static_url.form) this.static_url.form_id = this.static_url.form[0].id;


            // Just send User ID
            if(this.static_url.usersignofffrom) this.static_url.usersignofffrom_id = this.static_url.usersignofffrom[0].id;

            this.$store.commit('showBlockingSpinner')

			this.$cfetch(`${this.$settings.APIBaseURL}/staticurls/save`, {
  				method: 'post',
  				data: this.static_url,
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving static url')

                const id = res.result.id
                if(id && !this.$route.params.id) this.$router.push(`/settings/static-urls/edit/${id}`);

			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-saving-static-url'),
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
				this.submitting = false
			})
    	},
    	fetchStaticURL() {
			if (!this.$route.params.id) return Promise.resolve()

			this.$store.commit('showBlockingSpinner')

  			return this.$cfetch(`${this.$settings.APIBaseURL}/staticurls/get`, {
  				data: {
  					id: this.$route.params.id
  				}
  			})
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching stage')
				this.static_url = res.result
                this.total_url = res.baseURL

                if(!this.static_url.form) this.fetchForm();

                this.selectUser(this.static_url.usersignofffrom_id);

                //this.static_url.usersignofffrom = this.users.filter( user => user.id == this.static_url.usersignofffrom_id)
			})
			.catch(error => {
				this.$log.error.call(this, error)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-fetching-static-url'),
					confirmCallBack: function () {
						this.$router.push('/settings/static-urls')
					}
				})
			})
			.finally(() => {
				this.$store.commit('hideBlockingSpinner')
			})
    	},
        openDialog(action) {
            var self = this;
            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t(`${action}-static-url-warning`),
                cancelBtn: true,
                confirmCallBack: function () {
                    self.handleStaticURL(action)
                }
            })
        },
        handleStaticURL(action) {
            this.static_url.status = 1;

            if (action == 'delete'){
                this.static_url.status = 3;
            } else {
                if (action == 'disable') this.static_url.status = 2;
            }

            this.saveStaticURL();
        },
        fetchForm() {
            this.static_url.form = [];
            
            this.$cfetch(`${this.$settings.APIBaseURL}/forms/getform/${this.static_url.form_id}`)
			.then(res => {
				if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching worflow')

                this.static_url.form.push ({
                    id: res.form.id,
                    title: res.form.settings.title
                })
                
            })
			.catch(error => {
                console.log(error)
				this.$log.error.call(this, error)
				this.$store.commit('openDialog', {
					title: this.$t('something-went-wrong'),
					content: this.$t('error-fetching-form'),
					confirmCallBack: function () {
						this.$router.push('/settings/static-urls')
					}
				})
			})
        },
        getUsers() {
            this.$cfetch(`${this.$settings.APIBaseURL}/getusers`,
                {
                    method: "post",
                    data: {
                        priv: 'ACCESS_APP'
                    }
                }
            )
            .then(res => {
                if (res.status == "SUCCESS") {
                	this.users = res.users.map(user => {
                        return {
                            ...user,
                            displayname: user.displayName
                        }
                    });
                }
            })
            .catch(error => {
                this.$log.error.call(this, error);
            });
		},
        selectUser(id) {
            if (this.users.length > 0 && id) {
                this.static_url.usersignofffrom = this.users.filter(user => user.id == id);
            }
        },
        copyToClipboard(text) {
            const textarea = document.createElement("textarea");
            textarea.value = text;

            // Make the textarea out of the viewport to ensure it's not visible
            textarea.style.position = "fixed";
            textarea.style.opacity = 0;

            // Append the textarea to the DOM
            document.body.appendChild(textarea);

            // Select the text within the textarea
            textarea.select();

            // Copy the selected text to the clipboard
            document.execCommand("copy");

            // Remove the textarea from the DOM as it's no longer needed
            document.body.removeChild(textarea);

            this.copied = true;
        }
    },
    computed: {
  		roleoptions() {
  			const options = [];
  			for(let role of this.$config.getValue('roles')) {
  				options.push({ text: role.name, value: role.id });
  			}
  			return options;
  		},
        canSave() {
            return this.static_url.title.length && this.static_url.form.length && this.static_url.usersignofffrom.length
            || !this.loading
        },
        singleForm(){
            if(this.static_url.form && this.static_url.form.length>0) return true;
            return false;
        },
        currentStatusText() {
            if (this.static_url.status && this.static_url.status == 1)  return this.$t('active');

            return this.$t('disabled');

        },
        baseURL() {
            return this.total_url;
        }
    },
}
</script>
